import {featureFlags} from '@dms/feature-flags';

import {useGetTenantInfo} from '../hooks/useGetTenantInfo';
import {VehicleForm as VFKit} from '../VehicleForm';

export function EngineSpecsGroup() {
  const {isBelgianTenant} = useGetTenantInfo();

  return (
    <>
      <VFKit.SimpleNumericField name="power" />
      <VFKit.ShowWhen whenFeatureEnabled={featureFlags.CORE_MAX_POWER}>
        <VFKit.SimpleNumericField name="maximalPower" />
      </VFKit.ShowWhen>
      <VFKit.ShowWhen when={isBelgianTenant}>
        <>
          <VFKit.EngineVolumeField />
          <VFKit.FiscalPowerField />
        </>
      </VFKit.ShowWhen>
      <VFKit.ShowWhen when={!isBelgianTenant}>
        <VFKit.SimpleNumericField name="engineVolume" />
      </VFKit.ShowWhen>

      <VFKit.SimpleNumericField name="cylinderCount" />
    </>
  );
}
